import { cn } from 'utils/cn';

type Props = {
	className?: string;
	type?: 'info' | 'success' | 'warning' | 'error';
};

export function Dot({ className, type }: Props) {
	return (
		<div
			class={cn(
				'rounded-full w-2 h-2',
				className,
				type === 'info' && 'bg-dark-blue-25',
				type === 'success' && 'bg-green',
				type === 'warning' && 'bg-warning',
				type === 'error' && 'bg-red',
			)}
		/>
	);
}
